export enum OriginType {
  NoPreference = 0,
  UK = 1,
  USA = 2,
  Australia = 3,
}

export enum CurrencyType {
  Native = 0,
  GBP = 1,
  USD = 2,
}

export enum SearchSort {
  Relevant = 0,
  Popular = 1,
  PriceAsc = 2,
  PriceDesc = 3,
  TitleAsc = 4,
  TitleDesc = 5,
}

export interface FacetResponse {
  Numbers: FacetsNumberResponse[];
  Strings: FacetsStringResponse[];
}
export interface FacetsNumberRequest extends FacetBase {
  Min: number;
  Max: number;
}
export interface FacetsNumberResponse extends FacetBase {
  ActualMin: number;
  Min: number;
  Max: number;
  ActualMax: number;
  Avg: number;
  Count: number;
}
export interface FacetsStringRequest extends FacetBase {
  Values: string[];
}
export interface FacetBase {
  Name: string;
}
export interface FacetsStringResponse extends FacetBase {
  Values: ValueCount[];
}
export interface IDCount {
  ID: number;
  Count: number;
}
export interface ProductDetails extends ProductDetailsBase {
  CampaignID?: number;
  Description: string;
  Products: ProductVariation[];
  Specifications: FacetBase[];
}
export interface ProductDetailsBase {
  /** The count of Variants that are Available */
  AvailableProducts: number;
  /** The ID of the group of variants. */
  CommonDetailID: number;
  CurrencySymbol: string;
  ExchangeRate: number;
  /** Gets the minimum discounted cost of the variations to use in the "From" part of the product details page */
  FromCost: number;
  IsBook: boolean;
  SupplierID: string;
  Title: string;
}
export interface ProductDetailsEMS extends ProductDetails {
  ProductPages: ProductPageDetails[];
  Products: ProductVariationEMS[];
}
export interface ProductImage {
  ID: number;
  Url: string;
  SmallUrl: string;
  ThumbnailUrl: string;
}
export interface ProductPageDetails {
  ProductPageID: number;
  Url: string;
  ErrorCount: number;
  LastChecked?: Date;
  NextCheck?: Date;
}
export interface ProductSearchResult extends ProductDetailsBase {
  ImageUrl: string;
  OverlayID?: number;
  /** The ID of one specific variant product. */
  ProductID?: number;
  Variations: number;
}
export interface ProductVariation {
  Available: boolean;
  Commodity: number;
  Cost: number;
  DiscCost: number;
  Highlight: boolean;
  ProductID: number;
  SKU: string;
  Specific: FacetBase[];
  Status: string;
  Unit: string;
}
export interface ProductVariationEMS extends ProductVariation {
  EMSDiscount: number;
  EMSProductStatus: string;
  LastImported?: Date;
  LastUpdated?: Date;
  PricingExpiry?: Date;
  RRP: number;
}
export interface SearchRequest {
  Page?: number;
  Size?: number;
  Keywords: string;
  DepartmentID?: number;
  CampaignID?: number;
  SupplierIDs: number[];
  StringFacets: FacetsStringRequest[];
  NumberFacets: FacetsNumberRequest[];
  Sort: SearchSort;
  Currency: CurrencyType;
  Origin: OriginType;
}
export interface SearchResult {
  ResultCount: number;
  Results: ProductSearchResult[];
}
export interface SearchResultWithFacets extends SearchResult {
  DepartmentIDs: IDCount[];
  SupplierIDs: IDCount[];
}
export interface ValueCount {
  Value: string;
  Count: number;
}